﻿import $ from "cash-dom";
import anime from 'animejs';
import barba from "@barba/core";

import WindowUtils from './utils/WindowUtils';
import Utils from "./utils/Utils";

const WU = new WindowUtils();
if (WU.isTouch()) {
    $('html').addClass('isTouch');
}

let cursor = document.querySelector('.cursor');
let cursorCover = document.querySelector('.cursorCover');
let introTimeout = null;
let introSkipped = false;

const isHome = () => $('body').hasClass('home');
const isProject = () => $('body').hasClass('single-projet');
const isAbout = () => $('body').hasClass('page-template-tpl-about');

// ----------------------------------------------
// Load images & render its ---------------------
// ----------------------------------------------
const loadImages = () => {
    $('.imageRender:not(.imageRender--loaded)').each(function(){
        let img = $(this);
        let url = img.attr('data-url');
        let cover = img.find('.imageRender_cover');
        
        Utils.loadImage(url).then(() => {
            cover.css('background-image', 'url(' + url + ')');
            img.addClass('imageRender--loaded');
        });
    });
};

// ----------------------------------------------
// Cursor events --------------------------------
// ----------------------------------------------
window.addEventListener('mousemove', e => {
    cursor.style.opacity = 1;
    cursor.style.transform = 'translate(' + e.clientX + 'px,' + e.clientY + 'px)';
    cursorCover.style.opacity = 1;
    cursorCover.style.transform = 'translate(' + e.clientX + 'px,' + e.clientY + 'px)';
});

window.addEventListener('mouseleave', () => {
    cursor.style.opacity = 0;
    cursorCover.style.opacity = 0;
});

const hideIntro = () => {
    if (introSkipped) return;

    introSkipped = true;

    document.querySelector('.marquee--index').classList.add('visible'); 

    let TL = anime.timeline({
        easing: 'easeOutExpo',
        duration: 800,
    });
    
    TL.add({ targets: '.intro', opacity: [1,0], duration: 600, easing: 'easeOutCirc', complete: () => { $('.intro').hide(); } });

    return TL;
};

const indexAnimation = () => {
    anime({
        targets: '.index .index_col',
        opacity: [0,1],
        translateY: ['101vh', 0],
        easing: 'easeOutExpo',
        duration: 2200,
        delay: anime.stagger(200)
    });
};


/* ------------------------------------ */
/* --------- Homepage Carousel -------- */
/* ------------------------------------ */
let items, prevButton, nextButton, currentSlideIndex, currentSlide,
prevSlide, totalSlides, xDown, yDown, animating, hasHomeCarousel;

const carouselPrev = () => {
    if (animating) return;
    
    animating = true;

    prevSlide = currentSlide;
    currentSlideIndex = (currentSlideIndex === 0) ? totalSlides - 1 : currentSlideIndex - 1;
    currentSlide = items[currentSlideIndex];
    prevSlide.classList.remove('active');
    currentSlide.classList.add('active');

    currentSlide.scrollTop = 0;

    anime({
        targets: prevSlide,
        translateX: [0, '101vw'],
        opacity: [1, 0],
        duration: 1400,
        easing: 'easeInOutExpo',
        complete: () => {
            prevSlide.classList.remove('active');
        }
    });

    anime({
        targets: currentSlide,
        translateX: ['-101vw', 0],
        opacity: [0, 1],
        duration: 1400,
        easing: 'easeInOutExpo',
        complete: () => {
            currentSlide.classList.add('active');
            animating = false;
        }
    });
};

const carouselNext = () => {
    if (animating) return;

    animating = true;

    prevSlide = currentSlide;
    currentSlideIndex = (currentSlideIndex === totalSlides - 1) ? 0 : currentSlideIndex + 1;
    currentSlide = items[currentSlideIndex];

    currentSlide.scrollTop = 0;

    anime({
        targets: prevSlide,
        translateX: [0, '-101vw'],
        opacity: [1, 0],
        duration: 1400,
        easing: 'easeInOutExpo',
        complete: () => {
            prevSlide.classList.remove('active');
        }
    });

    anime({
        targets: currentSlide,
        translateX: ['101vw', 0],
        opacity: [0, 1],
        duration: 1400,
        easing: 'easeInOutExpo',
        complete: () => {
            currentSlide.classList.add('active');
            animating = false;
        }
    });
};

const getTouches = (evt) => {
    return evt.touches || evt.originalEvent.touches;
}                                                     

const handleTouchStart = (evt) => {
    if (animating) return;
    const firstTouch = getTouches(evt)[0];                                      
    xDown = firstTouch.clientX;                                      
    yDown = firstTouch.clientY;                                      
};                                                

const handleTouchMove = (evt) => {
    if (animating) return;
    if ( ! xDown || ! yDown ) {
        return;
    }

    var xUp = evt.touches[0].clientX;                                    
    var yUp = evt.touches[0].clientY;

    var xDiff = xDown - xUp;
    var yDiff = yDown - yUp;

    if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {
        if ( xDiff > 0 ) {
            carouselNext();
        } else {
            carouselPrev();
        }                       
    }
    xDown = null;
    yDown = null;                                             
};

const initHomeCarousel = () => {
    container = document.querySelector('.index');
    items = document.querySelectorAll('.index_col');
    prevButton = document.querySelector('.prevButton');
    nextButton = document.querySelector('.nextButton');
    currentSlideIndex = 0;
    currentSlide = null;
    prevSlide = null;
    totalSlides = 0;
    xDown = null;                                                        
    yDown = null;
    animating = false;
    hasHomeCarousel = window.innerWidth < 768;
};

const createHomeCarousel = () => {
    initHomeCarousel();

    totalSlides = items.length;
    currentSlide = items[currentSlideIndex];

    currentSlide.classList.add('active');

    prevButton.addEventListener('click', (e) => {
        e.preventDefault();
        carouselPrev();
        console.log("prev");
    });

    nextButton.addEventListener('click', (e) => {
        e.preventDefault();
        carouselNext();
    });

    document.addEventListener('touchstart', handleTouchStart, false);        
    document.addEventListener('touchmove', handleTouchMove, false);    
};

const initPage = () => {
    loadImages();
    
    // ----------------------------------------------
    // Cursor events --------------------------------
    // ----------------------------------------------
    document.querySelectorAll('[data-cursor]').forEach((link) => {
        link.addEventListener('mouseover', (e) => {
            cursor.classList.remove('disable');
            cursorCover.classList.remove('disable');
            cursorCover.querySelector('img').src = '';

            if (link.getAttribute('data-cursor')) {
                cursor.setAttribute('data-state', link.getAttribute('data-cursor'));
            } else {
                cursor.setAttribute('data-state', '');
            }

            if (link.getAttribute('data-cover')) {
                cursorCover.querySelector('img').src = link.getAttribute('data-cover');
            } else {
                cursorCover.classList.add('disable');
            }

            e.stopPropagation();
        });

        link.addEventListener('mouseout', (e) => {
            cursor.classList.add('disable');
            cursor.setAttribute('data-state', '');
            cursorCover.classList.add('disable');
            e.stopPropagation();
        });
    });

    if (isHome()) {
        if (introTimeout) { clearTimeout(introTimeout); }

        let introAreas = document.querySelectorAll('.intro_area');
        let introImgs = document.querySelectorAll('.intro_img');
        let introImgsStagger = 250;

        if (window.innerWidth < 768) {
            createHomeCarousel();

            setTimeout(() => {
                introImgs.forEach((img, index) => {
                    setTimeout(() => {
                        if (document.querySelector('.intro_img.visible')) {
                            document.querySelector('.intro_img.visible').classList.remove('visible');
                        }
                        img.classList.add('visible');
                    }, index * introImgsStagger);
                })
                setTimeout(() => {
                    if (document.querySelector('.intro_img.visible')) {
                        document.querySelector('.intro_img.visible').classList.remove('visible');
                    }
                }, introImgsStagger * (introImgs.length + 3));
            }, 1500);
        }

        if (introAreas.length > 0){
            introAreas.forEach((area) => {
                area.addEventListener('mouseenter', () => {
                    let item = area.getAttribute('data-item');

                    if (document.querySelector('.intro_img.visible')) {
                        document.querySelector('.intro_img.visible').classList.remove('visible');
                    }

                    introImgs[item].classList.add('visible');
                });
            })
        }

        if (!introSkipped) {
            document.querySelector('.marquee--intro').classList.remove('hidden'); 
            setTimeout(() => {
                introTimeout = setTimeout(() => {
                    hideIntro().finished.then(() => {
                        if (!hasHomeCarousel) {
                            indexAnimation();
                        }
                    });
                }, 6000);
            }, 500);

        } else {
            $('.intro').hide();
            document.querySelector('.marquee--index').classList.add('visible'); 
            if (!hasHomeCarousel) {
                indexAnimation();
            }
        }

        document.querySelector('.intro_plus').addEventListener('click', () => {
            clearTimeout(introTimeout);
            hideIntro().finished.then(() => {
                if (!hasHomeCarousel) {
                    indexAnimation();
                }
            })
        });

    }

    if (isProject()) {
        let DOM = {
            hardzone: document.querySelector('.project_coverSmall'),
            zoom: document.querySelector('.project_coverSmall_zoom'),
            coverWrap: document.querySelector('.project_zoom'),
            cover: document.querySelector('.project_zoom_cover')
        };

        const coverOriginalWidth = parseInt(DOM.cover.getAttribute('data-width'));
        const coverOriginalHeight = parseInt(DOM.cover.getAttribute('data-height'));
        const coverOriginalRatio = coverOriginalHeight / coverOriginalWidth;
        let zoomValue = 2;

        let hardzoneBounding, zoomBounding, coverWrapBounding;
        let newH, newW;
        let zoomH, zoomW;

        const setCoverSize = () => {
            hardzoneBounding = DOM.hardzone.getBoundingClientRect();
            coverWrapBounding = DOM.coverWrap.getBoundingClientRect();
            
            if (coverOriginalRatio > 1) {
                newW = coverWrapBounding.width * zoomValue;
                newH = coverOriginalHeight * newW / coverOriginalWidth;
                zoomW = hardzoneBounding.width / zoomValue;
                zoomH = hardzoneBounding.width * (coverWrapBounding.height / coverWrapBounding.width) / zoomValue;
            } else {
                newH = coverWrapBounding.height * zoomValue;
                newW = coverOriginalWidth * newH / coverOriginalHeight;
                zoomH = hardzoneBounding.height / zoomValue;
                zoomW = hardzoneBounding.height * (coverWrapBounding.width / coverWrapBounding.height) / zoomValue;
            }

            DOM.cover.style.height = newH + "px";
            DOM.cover.style.width = newW + "px";

            DOM.zoom.style.height = zoomH + "px";
            DOM.zoom.style.width = zoomW + "px";
            DOM.zoom.style.marginTop = zoomH/-2 + "px";
            DOM.zoom.style.marginLeft = zoomW/-2 + "px";
            DOM.zoom.style.backgroundSize = hardzoneBounding.width + "px " + hardzoneBounding.height + "px";

            zoomBounding = DOM.zoom.getBoundingClientRect();
        };

        DOM.hardzone.addEventListener('mousemove', (e) => {
            DOM.coverWrap.classList.add('active');

            let xPct = Utils.clamp((e.clientX - hardzoneBounding.left) / hardzoneBounding.width, 0, 1);
            let yPct = Utils.clamp((e.clientY - hardzoneBounding.top) / hardzoneBounding.height, 0, 1);
            
            let translateX = Utils.clamp(xPct * hardzoneBounding.width, zoomBounding.width/2, hardzoneBounding.width - (zoomBounding.width/2));
            let translateY = Utils.clamp(yPct * hardzoneBounding.height, zoomBounding.height/2, hardzoneBounding.height - (zoomBounding.height/2));

            DOM.zoom.style.transform = "translate(" + translateX + "px," + translateY + "px)";
            // DOM.zoom.style.backgroundPosition = ((translateX + 2 - zoomBounding.width/2) * -1) + "px " + ((translateY + 2 - zoomBounding.height/2) * -1) + "px";
            DOM.cover.style.transform = "translate(" + (translateX / hardzoneBounding.width) * -100 + "%," + (translateY / hardzoneBounding.height) * -100 + "%)";

            e.stopPropagation();
        });
        
        DOM.hardzone.addEventListener('mouseleave', () => {
            DOM.coverWrap.classList.remove('active');
        });

        setCoverSize();
        window.addEventListener('resize', setCoverSize);
    }

    if (isAbout()) {
        if (document.querySelector('.about_cover video')) {
            document.querySelector('.about_cover video').play();
        }

        let startDelay = 400;
        
        anime({
            targets: '.about_infos_inner .st2',
            translateY: [50, 0],
            opacity: [0, 1],
            duration: 1200,
            delay: startDelay,
            easing: 'easeOutExpo'
        });

        anime({
            targets: '.cols > div:nth-child(1)',
            translateY: [50, 0],
            opacity: [0, 1],
            duration: 1200,
            delay: startDelay + 200,
            easing: 'easeOutExpo'
        });

        anime({
            targets: '.cols > div:nth-child(2)',
            translateY: [50, 0],
            opacity: [0, 1],
            duration: 1200,
            delay:  startDelay + 300,
            easing: 'easeOutExpo'
        });
    }
    
    if (document.querySelector('.mobileMenuButton')) {
        document.querySelector('.mobileMenuButton').addEventListener('click', (e) => {
            e.preventDefault();
            document.querySelector('.menu').classList.add('open');
        });
        document.querySelector('.menu_close').addEventListener('click', (e) => {
            e.preventDefault();
            document.querySelector('.menu').classList.remove('open');
        });
    }

}

(function() {
    initPage();

    Utils.preloadHTMLImages(document.body.innerHTML).then(() => {
        // console.log("LOADED");
        loadImages();

        WU.scrollToTop();

        anime({
            targets: '.loadingScreen',
            translateX: ['0%','101%'],
            easing: 'easeOutExpo',
            duration: 1000,
            complete: () => {  }
        })
    });

    barba.init({
        debug: false,
        timeout: 10000,
        transitions: [
            {
                name: 'default',
                leave () {
                    return new Promise(resolve => {
                        anime({
                            targets: '.loadingScreen',
                            translateX: ['-101%','0%'],
                            easing: 'easeOutExpo',
                            duration: 1000,
                            complete: resolve
                        })
                    });
                },
                enter (data) {
                    let done = this.async();
                    Utils.preloadHTMLImages(data.next.html).then(() => {
                        done();
                        anime({
                            targets: '.loadingScreen',
                            translateX: ['0%','101%'],
                            easing: 'easeOutExpo',
                            duration: 1000
                        })
                    });
                }
            }
        ]
    });

    barba.hooks.enter((data) => {
        Utils.setNewAttrs(data.next.html);
        setTimeout(() => {
            initPage();
        }, 100);
    });

    barba.hooks.after(() => { });

})();